import { useState, useEffect } from 'react';
import Experiments from '@wix/wix-experiments';
import { EXPERIMENTS_SCOPE } from '../utils/constants';

const useExperiments = () => {
  const [experiments, setExperimants] = useState<Experiments | undefined>(
    undefined,
  );
  const [experimentsReady, setExperimentsReady] = useState<boolean>(false);

  useEffect(() => {
    async function waitExperimentsReady() {
      experiments!.ready().then(() => {
        setExperimentsReady(true);
      });
    }

    if (!experiments) {
      setExperimants(
        new Experiments({
          useNewApi: true,
          scope: EXPERIMENTS_SCOPE,
        }),
      );
    } else if (!experimentsReady) {
      waitExperimentsReady();
    }
  }, [experiments, experimentsReady]);

  return { experiments, experimentsReady };
};

export default useExperiments;
